export default __webpack_public_path__ + "static/media/generali-mobile.2838f5a8.png";